module.exports = __webpack_public_path__ + "img/coracao.bed171f3.png";